import { render, staticRenderFns } from "./BookingDialog.vue?vue&type=template&id=06377584&scoped=true"
import script from "./BookingDialog.vue?vue&type=script&lang=js"
export * from "./BookingDialog.vue?vue&type=script&lang=js"
import style0 from "./BookingDialog.vue?vue&type=style&index=0&id=06377584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06377584",
  null
  
)

export default component.exports